import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { IImage } from '../../interfaces/definitions';
import { setTranslationKeys } from '../../translations';
import { NgMediaConfigService } from '../../services/ng-media-config.service';
import { UploadComponent } from '../upload/upload.component';

@Component({
  selector: 'ng-media-cropper',
  templateUrl: './ng-media-cropper.component.html',
  styleUrls: ['./ng-media-cropper.component.scss']
})
export class NgMediaCropperComponent implements OnInit {
  @Input() public type: 'single' | 'multiple' | 'editor' = 'editor';
  @Input() public enableUpload = true;
  @Input() public fileViewer = true;
  @Input() public folder = '';
  @Input() public cropPreview = false;
  @Input() public uploadButton = false;
  @Input() public maxFileSize = null;
  @Input() public allowedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
  @Input() public set apiPrefix(value) {
    this.config.API.next(value);
  }
  @Output() public selectionChange: EventEmitter<
    Array<IImage>
  > = new EventEmitter();
  @Output() public eventChange;
  @Output() public imageDelete;
  @Output() public uploadFinish: EventEmitter<any> = new EventEmitter();
  @Output() public cropChange: EventEmitter<Array<File>> = new EventEmitter();
  @Output() public uploadProgress: EventEmitter<any> = new EventEmitter();
  @Output() public uploadFailed: EventEmitter<any> = new EventEmitter();
  @Input() public translations = null;

  @ViewChild('uploader', { static: true })
  uploader: UploadComponent;

  public imageEvent = null;
  public croppedImage: File = null;

  constructor(private config: NgMediaConfigService) {}

  public updateSelection(items: Array<IImage> = []) {
    this.selectionChange.emit(items);
  }

  ngOnInit() {
    if (this.translations) {
      setTranslationKeys(this.translations);
    }
  }

  public croppedImageChange(event: any) {
    this.croppedImage = event.file;
    this.cropChange.next(event);
  }

  public uploadCropped() {
    this.uploader.UploadToCloud(this.croppedImage, null);
  }

  // @todo If we want to support multiple file crop at the same time edit here
  public fileEvent(files: Array<File>) {
    this.imageEvent = files[0];
  }
}
